import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import ParentPortfolioFormContainer from '../../containers/parent-portfolio/ParentPortfolioFormContainer.jsx';

const NewParentPortfolio = () => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('parentPortfolio')} | ChangeSync</title>
    </Helmet>
    <ParentPortfolioFormContainer />
  </>
);

export default requireAuth(NewParentPortfolio);
